export const isFullUrl = (url) => {
    return url?.startsWith('http://') || url?.startsWith('https://');
};
export const fixVideoThumbnailFromMobile = (url) => {
    let resultUrl = url;
    if (url) {
        if (isFullUrl(url)) {
            // at this place the url for thumbnail can be absolute
            //   and we should cut the media id from the full url (specific for mobile media manager)
            resultUrl = url.match(/\/(media\/.*?\..*?)(\/|$)/)?.[1];
            if (!resultUrl) {
                console.error('Error with absolute thumbnail url:', url);
            }
        }
        else if (!url.includes('media/')) {
            resultUrl = `media/${url}`;
        }
    }
    return resultUrl;
};
export function getVideoUrl(url) {
    return ('https://video.wixstatic.com/' +
        (url?.split('/').length > 2 ? url : `${url}/720p/mp4/file.mp4`));
}
export const getVideoTypeFromUrl = (url) => {
    return `video/${url.split('.').pop()}`;
};
//# sourceMappingURL=video.js.map